/* unplugin-vue-components disabled */import { render } from "./ThreeRender.vue?vue&type=template&id=e85cca06&scoped=true"
import script from "./ThreeRender.vue?vue&type=script&lang=js"
export * from "./ThreeRender.vue?vue&type=script&lang=js"

import "./ThreeRender.vue?vue&type=style&index=0&id=e85cca06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85cca06"]])

export default __exports__